import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import Hyperlink from '@ingka/hyperlink';
import { config } from '../../config';
import { getCredentialUrl } from '../../utils';
import styled from 'styled-components';
import NoStoreSelected from '../../containers/Events/NoStoreSelected';
import Divider from '../Divider';
import ConditionalRender from '../ConditionalRender';
import LiveBroadcast from '../../containers/Events/LiveBroadcast';

const NoEventsHeader = styled.h2`
  font-size: var(--font-size-800);
  font-weight: bold;
  color: var(--colour-text-dark);
`;

const Wrapper = styled.div`
  ${({ theme }) => `${theme.breakpoints.lg} {
    margin-bottom: var(--space-400);
  }`}

  h1,h2 {
    margin-bottom: var(--space-100);

    ${({ theme }) => `${theme.breakpoints.lg} {
      margin-bottom: var(--space-150);
    }`}
  }

  p:not(${NoEventsHeader}) {
    margin-bottom: var(--space-200);
    ${({ theme }) => `${theme.breakpoints.lg} {
        max-width: 550px;
        margin-bottom: var(--space-300);
      }`}
  }
`;

const EventDesc = styled.p`
  white-space: pre-line;
`;

const NoEvents = ({ showCarousel = true }) => {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <NoEventsHeader>{t('event.noEvents')}</NoEventsHeader>
      <EventDesc>{t('event.noEventsDesc')}</EventDesc>
      <h2>{t('event.stayUptoDate')}</h2>
      <p>
        <Trans
          i18nKey="event.joinIKEAFamily"
          components={{
            JoinLink: (
              <Hyperlink
                url={getCredentialUrl(config.joinIkeaFamily)}
                text={t('event.joinIKEAFamilyLink')}
              />
            ),
            JoinLinkBusiness: (
              <Hyperlink
                url={getCredentialUrl(config.joinIkeaBusinessNetwork)}
                text={t('event.ikeaBusinessNetwork')}
              />
            ),
          }}
        />
      </p>
      <ConditionalRender predicate={showCarousel}>
        <NoStoreSelected showStayInformedText={false} renderNoEvents={false} />
        <Divider />
        <LiveBroadcast showStayInformedText={false} renderNoEvents={false} />
      </ConditionalRender>
    </Wrapper>
  );
};
export default React.memo(NoEvents);